import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { authAPI } from '../lib/api';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('verifying'); // 'verifying' | 'success' | 'error'
  const [email, setEmail] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setErrorMsg('No verification token provided');
      return;
    }
    authAPI.verifyEmail(token)
      .then(res => {
        setStatus('success');
        setEmail(res.data.email || '');
      })
      .catch(err => {
        setStatus('error');
        setErrorMsg(err.response?.data?.detail || 'Verification failed');
      });
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center p-8" data-testid="verify-email-page">
      <div className="w-full max-w-sm text-center space-y-6">
        {status === 'verifying' && (
          <>
            <Loader2 className="w-10 h-10 animate-spin mx-auto text-muted-foreground" />
            <h2 className="text-xl font-semibold">Verifying your email...</h2>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-100 dark:bg-green-900/30">
              <CheckCircle className="w-8 h-8 text-green-600" />
            </div>
            <h2 className="text-xl font-semibold">Email Verified!</h2>
            <p className="text-sm text-muted-foreground">{email} has been successfully verified.</p>
            <Button onClick={() => navigate('/auth')} className="bg-[hsl(var(--brand))] hover:bg-[hsl(var(--brand))]/90 text-white" data-testid="go-to-login">
              Go to Sign In
            </Button>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-100 dark:bg-red-900/30">
              <XCircle className="w-8 h-8 text-red-600" />
            </div>
            <h2 className="text-xl font-semibold">Verification Failed</h2>
            <p className="text-sm text-muted-foreground">{errorMsg}</p>
            <Button onClick={() => navigate('/auth')} variant="outline" data-testid="go-to-login-error">
              Go to Sign In
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
